import { Typography } from '@euler/app/components/typography';
import { ApdmImportState } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ActivityIndicator, View } from 'react-native';
import { useTheme } from 'styled-components';

const kLines: Partial<Record<ApdmImportState['kind'], string>> = {
  ready: '已整理好，确认无误后开始导入。',
  publishing: '正在导入，完成前客户会陆续出现在营销名单里。',
  published: '已导入。',
  deleted: '已删除。',
};

/** One line on where the import stands, for the states that need one. */
export function ImportStatusLine({ state }: { state: ApdmImportState }) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  const line =
    state.kind === 'failed'
      ? state.restartable
        ? '导入中途停止了，可以重新开始。'
        : '这份文件没能导入，请删除后换一份文件再试。'
      : kLines[state.kind];
  if (!line) return null;
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: rpx(8),
        marginBottom: rpx(12),
      }}
    >
      {state.kind === 'publishing' ? (
        <ActivityIndicator size="small" color={theme.colors.primary} />
      ) : null}
      <Typography.Text
        size={rpx(14)}
        color={
          state.kind === 'failed'
            ? theme.colors.status.danger
            : theme.label.color
        }
      >
        {line}
      </Typography.Text>
    </View>
  );
}
